module.exports = __webpack_public_path__ + "img/logo-police.58f55c5c.png";